import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';

class SingleSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { values: null, selected: null };
    }


    componentDidMount() {
        var values = JSON.parse(this.props.values);

        this.setState({ values: values });

    }

    render() {
        return (
            <div>
                <span className="p-fluid">
                    <Dropdown value={this.state.selected} options={this.state.values} onChange={(e) => this.setState({ selected: e.value })} optionLabel="name" placeholder="Select" filter />
                    <input name='single_select' type="hidden" value={JSON.stringify(this.state.selected)} />
                </span>
            </div>
        )
    }
}

export default SingleSelect;